/**
 * @readonly
 * @enum {string}
 */
export const ChargingStationConnectorTypes = Object.freeze({
    CHADEMO: 'Chademo',
    GBT20234_PART_2: 'GBT20234Part2',
    GBT20234_PART_3: 'GBT20234Part3',
    IEC60309_AC1_PHASE_BLUE: 'IEC60309AC1PhaseBlue',
    IEC60309_AC3_PHASE_RED: 'IEC60309AC3PhaseRed',
    IEC60309_DC_WHITE: 'IEC60309DCWhite',
    IEC62196_TYPE_1: 'IEC62196Type1',
    IEC62196_TYPE_2_CABLE_ATTACHED: 'IEC62196Type2CableAttached',
    IEC62196_TYPE_2_CCS: 'IEC62196Type2CCS',
    IEC62196_TYPE_2_OUTLET: 'IEC62196Type2Outlet',
    IEC62196_TYPE_3: 'IEC62196Type3',
    IEC62196_Type_1_CCS: 'IEC62196Type1CCS',
    STANDARD_HOUSEHOLD_COUNTRY_SPECIFIC: 'StandardHouseholdCountrySpecific',
    TESLA: 'Tesla'
})
